import getIn from 'immutable-less/transmute/getIn';
export const noFilter = () => true;
export const filterMatch = matcher => singleItem => {
  const {
    path,
    value
  } = matcher;
  return getIn(path, singleItem) === value;
};